import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Date from '~/modules/common/components/Date';

const useStyles = makeStyles(theme => ({
  noRole: {
    fontStyle: 'italic'
  },
  roleList: {
    paddingTop: 0,
    marginTop: 0,
    paddingBottom: 0
  },
  effectiveDate: {
    display: 'flex',
    margin: 0,
    fontSize: theme.typography.pxToRem(10),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 'unset'
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  },
  divider: {
    borderTop: `1px solid ${theme.palette.common.white}`,
    marginBottom: theme.spacing(0.5)
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: theme.spacing(0.5),
    rowGap: theme.spacing(1)
  }
}));

const UserWithRoleScheduleToolTip = ({ effectiveSchedule = {} }) => {
  const classes = useStyles();

  const primaryRole = (effectiveSchedule.projectRoles || []).find(
    role => role.isPrimary
  );
  const additionalRoles = (effectiveSchedule.projectRoles || []).filter(
    role => !role.isPrimary
  );
  const effectiveDate = effectiveSchedule && effectiveSchedule.effectiveDate;

  return (
    <>
      <div className={classes.title}>
        <FormattedMessage id="resourceRoles.tooltipTitle" />
      </div>
      <div className={classes.divider} />
      <div className={classes.gridContainer}>
        <FormattedMessage id="resourceRoles.primaryRole" />
        <div data-qe-id="PrimaryRoleList">
          {primaryRole ? (
            primaryRole.projectRole.name
          ) : (
            <div className={classes.noRole}>
              <FormattedMessage id="resourceRoles.noRole" />
            </div>
          )}
        </div>
        {additionalRoles.length > 0 && (
          <>
            <FormattedMessage id="resourceRoles.additionalRoles" />:
            <div className={classes.rolesList} data-qe-id="AdditionalRoleList">
              {additionalRoles.map(role => (
                <div key={role.projectRole.name}>{role.projectRole.name}</div>
              ))}
            </div>
          </>
        )}
        {effectiveDate && (
          <div className={classes.effectiveDate}>
            <FormattedMessage id="roleInfoCard.asOfDate" />
            &nbsp;
            <Date value={effectiveDate} className={classes.effectiveDate} />
          </div>
        )}
      </div>
    </>
  );
};

UserWithRoleScheduleToolTip.propTypes = {
  effectiveSchedule: PropTypes.shape({
    projectRoles: PropTypes.arrayOf(
      PropTypes.shape({
        isPrimary: PropTypes.bool,
        projectRole: PropTypes.shape({
          name: PropTypes.string
        })
      })
    ),
    effectiveDate: PropTypes.object
  }).isRequired
};

export default UserWithRoleScheduleToolTip;
